import { createResourceBuilder } from '../resource';
import { EResourceMethod } from '../models/IPermission';
import { orgIdParam, regionParam, stackIdParam } from './builderHelper';

export const cloudLiveResources = {
  getAllLiveStacks: createResourceBuilder('/live/region/:region/stack', EResourceMethod.Get, regionParam()),
  getOrganizationLiveStacks: createResourceBuilder(
    '/live/organization/:organization_id/region/:region/stack',
    EResourceMethod.Get,
    orgIdParam(regionParam())
  ),
  createOrganizationLiveStack: createResourceBuilder(
    '/live/organization/:organization_id/region/:region/stack',
    EResourceMethod.Post,
    orgIdParam(regionParam())
  ),
  removeOrganizationLiveStack: createResourceBuilder(
    '/live/organization/:organization_id/region/:region/stack/:stack_id',
    EResourceMethod.Delete,
    orgIdParam(regionParam(stackIdParam()))
  ),
  getOrganizationLiveStackAccess: createResourceBuilder(
    '/live/organization/:organization_id/region/:region/stack/:stack_id/access',
    EResourceMethod.Get,
    orgIdParam(regionParam(stackIdParam()))
  ),
  startLiveStack: createResourceBuilder(
    '/live/organization/:organization_id/region/:region/stack/:stack_id/start',
    EResourceMethod.Post,
    orgIdParam(regionParam(stackIdParam()))
  ),
  stopLiveStack: createResourceBuilder(
    '/live/organization/:organization_id/region/:region/stack/:stack_id/stop',
    EResourceMethod.Post,
    orgIdParam(regionParam(stackIdParam()))
  ),
  getLiveRegions: createResourceBuilder('/live/regions', EResourceMethod.Get),
};
